import styles from "../assets/styles/componenets/aboutus.module.css";
import { useState, useEffect, useRef } from "react";

export default function AboutUs() {
    const contactUsRef = useRef(null);
    const [isContactUsVisible, setIsContactUsVisible] = useState(false);

    useEffect(() => {
        const contactUsObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsContactUsVisible(true);
                } else {
                    setIsContactUsVisible(false);
                }
            },
            { threshold: 0.3 }
        );

        if (contactUsRef.current) {
            contactUsObserver.observe(contactUsRef.current);
        }
    }, []);

    return (
        <div id="contact-us" className={styles.container}>
            <div className={styles.aboutUsContent}>
                <div
                    ref={contactUsRef}
                    className={`${styles.contactUs} ${
                        isContactUsVisible && styles.visible
                    }`}
                >
                    <div className={styles.contactUsCover}></div>
                    <div className={styles.contactUsHeader}>
                        <h1>Հետադարձ կապ</h1>
                        <p>
                        Մեզ համար կարևոր է ձեր կարծիքը։ Եթե հարցեր ունեք, աջակցություն եք պահանջում կամ պարզապես ցանկանում եք ավելին իմանալ մեր դպրոցի մասին, մեր թիմը պատրաստ է օգնելու։
                        </p>
                    </div>
                    <div className={styles.contactCard}>
                        <div>
                            <i className="fa-regular fa-envelope"></i>
                        </div>
                        <h1>Էլ. հասցե</h1>
                        <p>info@justlaw.am</p>
                        <a href="mailto:info@justlaw.am">Ուղարկել էլ. նամակ</a>
                    </div>
                    
                    <div className={styles.contactCard}>
                        <div>
                            <i className="fa-solid fa-phone"></i>
                        </div>
                        <h1>Հեռախոսահամար</h1>
                        <p>+37496640494</p>
                        <a href="tel:+37496640494">Զանգահարել</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

/**
 * 
 * 
 * <div className={styles.contactCard}>
                        <div>
                            <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <h1>Հասցե</h1>
                        <p>32 street 789</p>
                        <a
                            href="https://www.google.com/maps?q=New+York"
                            target="_blank"
                            rel="noreferrer"
                        >
                            View Location
                        </a>
                    </div>
 */